
import { defineComponent } from 'vue';
import { AppFormRow, AppFileUpload, AppButton, AppCard } from '@/components';
import { useTranslationExport } from '@/modules/translation/model/export';
import { ROUTE_NAME_TRANSLATION } from '@/modules/translation/router';

export default defineComponent({
    name: ROUTE_NAME_TRANSLATION.EXPORT,
    components: { AppFormRow, AppFileUpload, AppButton, AppCard },
    setup() {
        const { model, exportXml, importXml } = useTranslationExport();

        return { model, exportXml, importXml };
    }
});
